@if(loading) {
<div class="tw-flex tw-h-screen  tw-bg-[--palette-brit-red] tw-text-white">
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-8 tw-m-auto tw-animate-pulse">
    <img src="assets/images/logo/briteat-logo.svg" alt="BritEat platform" class="tw-w-80">
    <h1 class="tw-text-6xl tw-font-black">Brit Eat</h1>
    <div class="tw-text-3xl tw-font-semibold">Bon Appétit...</div>
    <div class="tw-text-sm">Copyright &#64;2024</div>
  </div>
</div>
} @else {
<div class="tw-relative tw-z-[1]">
  <router-outlet></router-outlet>
</div>
<!-- <div class="tw-fixed tw-top-0 tw-z-0 tw-h-screen tw-w-full tw-bg-cover tw-bg-no-repeat tw-bg-center tw-bg-red-600"
  [ngStyle]="{
    'background-image': 
      business?.UI?.['BackgroundImage'] 
      ? 'url(\'' + business?.UI?.['BackgroundImage'] + '\')' 
      : (business ? undefined : 'url(/assets/images/gallery/royal-guard-hd.jpg)')
    }">
  @if(!business || business?.UI?.['BackgroundImage']) {
  <div class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-backdrop-blur-sm tw-backdrop-brightness-50"></div>
  }
</div> -->

}

<div id="captcha-verifier"></div>
<brt-app-update [alertInterval]="300" />
@if(env && env != 'prod') {
<div class="tw-absolute tw-left-1 tw-top-1 tw-z-50 tw-rounded-xl tw-px-4 tw-py-1 tw-font-medium surface-danger tw-animate-pulse">
  {{env}}
</div>
}